import React from 'react'

import Attachment from "../../../../../model2/attachment/attachment"
import {AttachmentSystemType} from "../../../../../model2/attachment/@types"
import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../buttons/control-button/@types"

type Props = {
    className?    : string

    attachment    : Attachment

    isCustom?     : boolean
}

export default function AttachmentButtonOpenNewWindow(props: Props):any {

    if (!props.attachment) return false

    const onClick = (e: any) => {
        e.stopPropagation()

        switch (props.attachment?.systemType) {
            case AttachmentSystemType.CUSTOM:
                props.attachment.openByFileObject()
                break

            default:
                props.attachment.openInBrowser()
        }
    }

    return <ControlButtonStandard className = {props.className}
                                  size      = {ControlButtonSize.SIZE_28}
                                  iconClass = "i5-open-new-window fs-12"
                                  onClick   = {onClick}/>
}
